import { useRecoilState } from "recoil";
import "./SliderProject.css";
import { $ServerUrl } from "../../store";

export default function SliderProject(props) {
  let stylingSlider = {
    height: "70vh",
  };

  const [serverUrl] = useRecoilState($ServerUrl);

  return (
    <>
      <div
        id="carouselExampleAutoplaying"
        className="carousel slide slide-carosalll"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
        {props.imgs && props.imgs.length > 0 ? (
  props.imgs.map((imgUrl, index) => (
    <div
      className={`carousel-item ${index === 0 ? "active" : ""}`}
      key={index}
    >
      <img
        src={imgUrl}
        className="d-block w-100 styles-sliderr"
        alt={`slide-${index}`}
        style={props.stylingSlider && stylingSlider}
      />
    </div>
  ))
) : (
  <>
    <div className="carousel-item active">
      <img
        src={require("../../assats/a1.jpg")}
        className="d-block w-100 styles-sliderr"
        alt="default-1"
        style={props.stylingSlider && stylingSlider}
      />
    </div>
    <div className="carousel-item">
      <img
        src={require("../../assats/a2.jpg")}
        className="d-block w-100 styles-sliderr"
        alt="default-2"
        style={props.stylingSlider && stylingSlider}
      />
    </div>
    <div className="carousel-item">
      <img
        src={require("../../assats/a3.jpg")}
        className="d-block w-100 styles-sliderr"
        alt="default-3"
        style={props.stylingSlider && stylingSlider}
      />
    </div>
  </>
)}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </>
  );
}
